import { render, staticRenderFns } from "./AvatarBorderAnimation.vue?vue&type=template&id=2c4da37b&scoped=true&"
import script from "./AvatarBorderAnimation.vue?vue&type=script&lang=ts&"
export * from "./AvatarBorderAnimation.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarBorderAnimation.vue?vue&type=style&index=0&id=2c4da37b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4da37b",
  null
  
)

export default component.exports